import EmployeeShow from './EmployeeShow';
import EmployeeList from './EmployeeList';

export default {
  show: EmployeeShow,
  list: EmployeeList,
};
